import { render } from "./FriendCard-Friend.vue?vue&type=template&id=67d7782d&scoped=true"
import script from "./FriendCard-Friend.vue?vue&type=script&lang=js"
export * from "./FriendCard-Friend.vue?vue&type=script&lang=js"

import "./FriendCard-Friend.vue?vue&type=style&index=0&id=67d7782d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d7782d"]])

export default __exports__